import createAxe from '../../middlewares/Axe'

// moment js
import moment from 'moment';
moment.locale('en') // secure that date is english

import { push } from 'connected-react-router';
import { parsePhoneNumber } from 'libphonenumber-js';

import goToVerse from '../../middlewares/Axe/elevator.js';
import { getUTCDateString } from '../../helpers/time';

import * as types from './actionTypes';
import { startTransaction, endTransaction, setStage } from '../transactionActions'
import { sendToWallet, setDate, setIdTx, setTimeSent } from '../purchaseActions'
import { triggerError, digestErrorCode } from '../maintenanceActions';
import { setLimit, setPower, setRemaining, setClientID, setFirst, setFees, setSales, setFulfilledPolicies, setMaxTierStatus } from '../clientActions';
import { setLight, turnOFFLights } from '../lightActions';
import { closeModal, closeReminder } from '../modalActions';
import { retrieveInfo } from '../rateActions';
import { goLoading, outLoading } from '../loadingActions';
import { takePicture } from '../cameraActions'
import { setCurrFees } from '../feesActions'
import { saveDBSell } from '../dbActions'
import { getTiers } from '../tiersActions';
import { getDirectionFromList, setDirectionList } from '../viewActions'
import { removeSession } from '../sessionActions';
import { setConsents } from '../consentActions'

import { Loading as i18n, Errors as i18nErrors } from '../../middlewares/i18n';
import { track, identify, resetAnalytics } from '../../helpers/analytics';
import { setStateNotice } from '../clientActions';


const LOCATIONS = ['/','/finish-screen', '/maintenance-mode', '/clean-cash']; //Screen that shouldn't redirect

// 2 types of pin
// login = when user is logging in
// confirm = when user is confirming the pin
export const PinType = {
  Login: 'login',
  Confirm: 'confirm'
}

export function validPhone(phone){
  return async function(dispatch, getState){
    let lang = getState().i18n.language.current
    dispatch(goLoading(i18n[lang].loading))
    let phoneNumber = parsePhoneNumber(phone);
    let axe = createAxe(getState())
    try{
      let res = await axe('/3971cc86b21c6924/auth/phone',{
        method: 'POST',
        headers: {
          'Atm-Token': `Bearer ${getState().machine.atm_id}`
        },
        data:{
          country_code: phoneNumber.countryCallingCode,
          phone_number: phoneNumber.nationalNumber
        }
      })
      if(res.status === 200){
        let dateTx = moment().toISOString();
        goToVerse({ action: 'START_TX', date: dateTx })
        dispatch(setLight(0,"PPS"))
        dispatch(setDate(dateTx))
        dispatch(startTransaction())
        dispatch(retrieveInfo())
        dispatch(addAreaCode(phoneNumber.countryCallingCode));
        dispatch(addPhone(phoneNumber.nationalNumber));
        dispatch(addCompletePhone(phone))
        dispatch(setClientID(res.data.data.access_token))
        dispatch(addTier(res.data.data.enrollment_tier));
        identify(res.data.data.customer_id, {
          price: getState().rate.price,
          lang: getState().i18n.current,
          operator_name: getState().machine.operator_name,
          operator_id: getState().machine.operator_id,
          operator_street_address: getState().machine.operator_address,
          operator_street_address2: getState().machine.operator_address2,
          operator_city: getState().machine.operator_address.city,
          operator_state: getState().machine.operator_address.state,
          operator_zipcode: getState().machine.operator_address.zipcode,
          operator_country: getState().machine.operator_address.country,
          operator_full_address: getState().machine.operator_address.full_address,
          // TODO: Pass the state that the machine is in to Segment
          // TODO: machine_state: getState().machine.local_state,
          restricted: getState().client.hard_restricted,
        })
        if(res.data.data.direction === 'verify_phone'){
          dispatch(addCode(res.data.data.verification_code));
        }
        setTimeout(()=>{return dispatch(outLoading(res.data.data.direction))},1000)
      }
      else {
        setTimeout(() => {
          dispatch(outLoading())
          setTimeout(()=>{
            return dispatch(triggerError(i18nErrors[lang].invalidPhone))}, 500)
        }, 1000)
      }
    }
    catch(error){
      setTimeout(() => {
        dispatch(outLoading())
        setTimeout(()=>{
          return dispatch(triggerError(i18nErrors[lang].invalidPhone))}, 500)
      }, 1000)
    }
  }
}

function defaultError(){
  return function(dispatch, getState){
    setTimeout(() => {
      let lang = getState().i18n.language.current
      dispatch(outLoading())
      dispatch(triggerError(i18nErrors[lang].tryLater));
      setTimeout(()=>{ return dispatch(cancelOperation()) },4700)
    }, 1000)
  }
}

export function addTier(tier){
  return{
    type: types.ADD_TIER,
    tier
  }
}

export function addAreaCode(areaCode){
  return {
    type: types.ADD_AREA_CODE,
    areaCode
  }
}

export function addPhone(phone){
  return{
    type: types.VALID_PHONE,
    phone
  }
}

export function addCompletePhone(completePhone){
  return{
    type: types.ADD_COMPLETE_PHONE,
    completePhone
  }
}

export function addCode(code){
  return{
    type: types.ADD_CODE,
    code
  }
}

export function cancelOperation(cleanFinish = false){
  return async function (dispatch, getState){
    let currRoute = getState().router.location.pathname
    if(!['/','/maintenance-mode','/finish-screen'].includes(currRoute) && !cleanFinish)
      track('Cancel Operation', {
        current_route: currRoute
      })
    dispatch(removeSession())
    resetAnalytics()
    dispatch(closeModal())
    if(getState().machine.name === 'rick')
      dispatch(turnOFFLights())
    if(getState().transaction.init){
      dispatch(endTransaction())
      if(getState().modal.open_reminder){          //user left without canceling
        dispatch(closeReminder(false))
      }
      switch(currRoute){ //Basically this will happen if user left
        case '/insert_cash':
          if(!getState().purchase.exit){                  //the user already inserted a bill
            dispatch(sendToWallet())
          }
          break;
      }
      goToVerse({ action: 'FINISH_LAST_TX'})
      dispatch(canceledOperation())
      if(currRoute === '/loading')
        return dispatch(outLoading('finish-screen'));
      else
        return dispatch(push('/finish-screen'))
    }
    else {
      if(getState().transaction.stage !== 0)
        dispatch(setStage(0))
      if(LOCATIONS.indexOf(getState().router.location.pathname) === -1)
        return dispatch(push('/'))
      return dispatch(push('/'))
    }
  }
}

export function canceledOperation(){
  return{
    type: types.CANCEL_OPERATION
  }
}

//CODE VALIDATION
export function sendCode(code){
  return function(dispatch, getState){
    let lang = getState().i18n.language.current
    if (code === getState().auth.code){
      dispatch(goLoading(i18n[lang].sendingCode))
      dispatch(setLight(0,"PPS"))
      dispatch(invalidInput(''))
      dispatch(validCode())
      setTimeout(()=>{return dispatch(outLoading('create_pin'))},1000);
    }
    else{
      return dispatch(invalidInput(i18nErrors[lang].wrongCode)); 
    }
  }
}

//RESEND CODE TO PHONE
export function resendCode(){
  return async function(dispatch, getState){
    let lang = getState().i18n.language.current
    try{
      let axe = createAxe(getState())
      let res = await axe('/3971cc86b21c6924/auth/phone/new_verification_code',{
        method: 'POST',
        headers: {
          'Atm-Token': `Bearer ${getState().machine.atm_id}`
        },
        data:{
          country_code: getState().auth.areaCode,
          phone_number: getState().auth.phone
        }
      })
      dispatch(addCode(res.data.data.verification_code));
      return dispatch(codeResent())
    }
    catch(error) {
      return dispatch(triggerError(i18nErrors[lang].tryLater))
    }
  }
}

//CODE RESENT
export function codeResent(){
  return{
    type: types.CODE_RESENT
  }
}

export function invalidInput(errorMessage){
  return{
    type: types.INVALID_PIN,
    errorMessage
  }
}

//CREATE PIN ACTION
export function createPin(pin){
  return async function(dispatch, getState){
    let lang = getState().i18n.language.current
    dispatch(goLoading(i18n[lang].processing))
    try{
      let axe = createAxe(getState())
      let res = await axe('/3971cc86b21c6924/auth/pin/new',{
        method: 'POST',
        headers: {
          'Customer-Token': `Bearer ${getState().client.client_id}`,
          'Atm-Token': `Bearer ${getState().machine.atm_id}`
        },
        data: {
          pin: pin
        }
      })
      dispatch(setLight(0,"PPS"))
      dispatch(invalidInput(''))
      setTimeout(()=>{return dispatch(outLoading(res.data.data.direction))},1000)
    }
    catch(error){
      dispatch(outLoading())
      return dispatch(triggerError(i18nErrors[lang].tryLater))
    }
  }
}

export function processDefineTransactionResponse(data, headerDate) {
  return async function(dispatch, getState) {
    const directions = data.directions;

    let maxLimit = 0

    for (const fee of data.fees) {
      if (fee.max > maxLimit) {
        maxLimit = fee.max
      }
    }

    goToVerse({ action: 'ADD_TX_INFO', tx_id: data.idtx })
    dispatch(setDirectionList(directions))
    // TODO: remove the 3 lines below after deprecation of State Notices
    if(data.state_notice) {
      dispatch(setStateNotice(data.state_notice))
    }
    dispatch(saveDBSell({ idtx: data.idtx, custom_token: getState().client.client_id, date: getState().purchase.date }))
    dispatch(setLight(0,'PPS'))
    dispatch(pinVerified())
    dispatch(invalidInput(''))
    dispatch(setFirst(data.customer.first_name))
    dispatch(setFees(data.fees))
    dispatch(setCurrFees(data.fees))
    dispatch(setSales(data.sales))
    // power/limit stay for tier limit displays; the ticker
    // displays `remaining` only
    dispatch(setPower(data.power_used))
    dispatch(setRemaining(data.remaining_limit))
    dispatch(setDate(data.local_created_at))
    dispatch(setTimeSent(getUTCDateString(headerDate)))
    dispatch(setFulfilledPolicies(data.customer.policies_fulfilled))
    dispatch(setMaxTierStatus(data.customer.max_tier))
    dispatch(setTransactional(maxLimit))
    dispatch(setLimit(maxLimit))
    dispatch(getTiers('crypto'))
    // Handle consents from the API response
    if(data.consents && data.consents.length > 0) {
      dispatch(setConsents(data.consents))
    }
    setTimeout(() => {
      let direction = dispatch(getDirectionFromList())
      return dispatch(outLoading(direction))
    }, 500)
  }
}

// We are assuming right now that we always need to define the transaction
// later it's going to be a view
function processValidAuthResponseV3(data){
  return async function(dispatch, getState) {
    let lang = getState().i18n.language.current
    if(!data.directions || !data.directions.length) {
      return dispatch(digestErrorCode(
        500,
        () => { return dispatch(defaultError()) }
      ))
    }
    if(data.directions[0].direction === 'define_transaction') {
      try {
        let requestData = {
          fiat_type: "usd",
          asset_type: 'crypto',
          asset_id: getState().multicrypto.coin.id,
          language: lang  // Unity prints the receipt in it
        }

        let axe = createAxe(getState())
        let res = await axe('/3971cc86b21c6924/v2/sale/define-transaction-full', {
          method: 'POST',
          headers: {
            'Atm-Token': `Bearer ${getState().machine.atm_id}`,
            'Session-Id': getState().purchase.idtx
          },
          data: requestData
        })

        if(res.status === 200) {
          return dispatch(processDefineTransactionResponse(res.data, res.headers.date))
        }
        else {
          setTimeout(() => {
            dispatch(outLoading())
            return dispatch(invalidInput(i18nErrors[lang].tryAgain))
          }, 1000)
        }
      }
      catch(error){
        setTimeout(() => {
          dispatch(outLoading())
          return dispatch(invalidInput(i18nErrors[lang].tryAgain))
        }, 1000)
      }
    }
    else {
      dispatch(setDirectionList(data.directions))
      setTimeout(() => {
        let direction = dispatch(getDirectionFromList())
          return dispatch(outLoading(direction))
        }, 1000)
    }
  }
}

//VERIFY PIN
export function verifyPinV3(pin, pin_type){
  return async function(dispatch, getState){
    let lang = getState().i18n.language.current
    dispatch(goLoading(i18n[lang].loggingIn))
    dispatch(invalidInput(''))
    try{
      let axe = createAxe(getState())
      let res = await axe('/3971cc86b21c6924/v3/auth/pin/verify', {
        method: 'POST',
        headers: {
            'Customer-Token': `Bearer ${getState().client.client_id}`,
            'Atm-Token': `Bearer ${getState().machine.atm_id}`
        },
        data:{
          pin: pin
        }
      })

      if(res.status === 200){
        dispatch(setIdTx(res.data.data.idtx));
        setTimeout(() => {
          dispatch(takePicture('enter_pin'))
        }, 500)
        return dispatch(processValidAuthResponseV3(res.data.data))
      } else {
        setTimeout(() => {
          dispatch(outLoading())
          return dispatch(invalidInput(i18nErrors[lang].tryAgain))
        }, 1000)
      }
    }
    catch(error){
      if(error.response) {
        if (error.response.status === 440){
          setTimeout(() => {
            return dispatch(invalidPin(pin_type))
          }, 1000)
        }
        else
          return dispatch(digestErrorCode(
            error.response.status,
            () => { return dispatch(defaultError()) }
          ))
      }
      else {
        return dispatch(digestErrorCode(
          500,
          () => { return dispatch(defaultError()) }
        ))
      }
    }
  }
}

//VERIFY 2FA CODE
export function verifyOtpCodeV3(code){
  return async function(dispatch, getState){
    let lang = getState().i18n.language.current;
    dispatch(goLoading(i18n[lang].loggingIn));
    dispatch(invalidInput(''))
    try {
      let axe = createAxe(getState());
      let res = await axe('/3971cc86b21c6924/v3/auth/otp/verify', {
        method: 'POST',
        headers: {
          'Customer-Token': `Bearer ${getState().client.client_id}`,
          'Atm-Token': `Bearer ${getState().machine.atm_id}`
        },
        data: {
          code,
          idtx: getState().purchase.idtx,
        }
      });

      const data = res.data.data;

      if(res.status === 200) {
        return dispatch(processValidAuthResponseV3(data));
      } else {
        setTimeout(() => {
          dispatch(outLoading())
          return dispatch(invalidInput(i18nErrors[lang].tryAgain))
        }, 1000)
      }
    }
    catch(error){
      if (error.response) {
        if (error.response.status === 401) {
          setTimeout(() => dispatch(invalid2FACode()), 1000);
        } else {
          return dispatch(digestErrorCode(
            error.response.status,
            () => { return dispatch(defaultError()) }
          ));
        }
      } else {
        return dispatch(digestErrorCode(
          500,
          () => { return dispatch(defaultError()) }
        ));
      }
    }
  }
}

function invalid2FACode() {
  return function(dispatch, getState) {
    let lang = getState().i18n.language.current
    dispatch(outLoading())
    return dispatch(invalidInput(i18nErrors[lang].wrongCode));
  }
}

function invalidPin(pin_type) {
  return function(dispatch, getState) {
    let lang = getState().i18n.language.current
    dispatch(outLoading())
    if(pin_type == PinType.Login)
      return dispatch(invalidInput(i18nErrors[lang].wrongPin));
    else
      return dispatch(invalidInput(i18nErrors[lang].unmatchPin));
  }
}

export function updatePin(pin){
  return async function(dispatch, getState){
    let lang = getState().i18n.language.current
    dispatch(goLoading(i18n[lang].processing))
    try{
      let axe = createAxe(getState())
      let res = await axe('/3971cc86b21c6924/auth/pin',{
        method: 'PUT',
        headers: {
          'Customer-Token': `Bearer ${getState().client.client_id}`,
          'Atm-Token': `Bearer ${getState().machine.atm_id}`
        },
        data: {
          pin: pin
        }
      })
      dispatch(setLight(0,"PPS"))
      dispatch(invalidInput(''))
      if(res.data.data && res.data.data.direction)
        return dispatch(outLoading(res.data.data.direction))
      return dispatch(outLoading('password_changed'))
    }
    catch(error){
      dispatch(outLoading())
      return dispatch(triggerError(i18nErrors[lang].tryLater))
    }
  }
}

// Request for challenge
function authChallenge(url, data, verification = false) {
  return async function(dispatch, getState){
    try{
      dispatch(invalidInput(''))
      let axe = createAxe(getState())
      let res = await axe(`/3971cc86b21c6924/authn/${url}`,{
        method: 'POST',
        headers: {
          'Atm-Token': `Bearer ${getState().machine.atm_id}`
        },
        data: data
      })
      dispatch(setLight(0,"PPS"))
      if(verification)
        dispatch(setClientID(res.data.data.access_token))
      setTimeout(() => {
        return dispatch(outLoading(res.data.data.direction))
      }, 1000)
    }
    catch(error){
      let lang = getState().i18n.language.current
      let message = i18nErrors[lang].tryLater
      if(error.response && error.response.status)
        message = i18nErrors[lang].wrongCode

      dispatch(outLoading())
      return dispatch(triggerError(message))
    }
  }
}

// Verifies the challenge (we go to next screen)
export function verifyChallenge(code) {
  return function(dispatch, getState){
    let lang = getState().i18n.language.current
    dispatch(goLoading(i18n[lang].processing))

    let data  = {
      country_code: getState().auth.areaCode,
      phone_number: getState().auth.phone,
      verification_code: code
    }

    return dispatch(authChallenge('challenge/verify', data, true))
  }
}

// Sends a challenge to a phone number
export function sendChallenge(){
  return function(dispatch, getState){
    let data  = {
      country_code: getState().auth.areaCode,
      phone_number: getState().auth.phone
    }

    return dispatch(authChallenge('challenge', data))
  }
}

// Starts the challenge (generally triggered when start process)
export function startChallenge() {
  return function(dispatch, getState){
    let lang = getState().i18n.language.current
    dispatch(goLoading(i18n[lang].sendingCode))

    return dispatch(sendChallenge())
  }
}

export function setTransactional(transactional){
  return{
    type: types.SET_TRANSACTIONAL,
    transactional
  }
}

export function pinVerified(){
  return{
    type: types.PIN_VERIFIED
  }
}

export function validCode(){
  return{
    type: types.VALID_CODE
  }
}